module.exports = "/fonts/gt-walsheim-light.ttf";